<div
  class="container p-24 flex-row full column align-center border-radius-16 border-radius-md-0 border-radius-md-top-left-40 border-radius-md-top-right-40 bg-color-1E2025 p-md-24">
  <div class="flex-row align-center full content-between mb-40">
    <div class="flex-row column">
      <h4 class="fs-24 lh-32 fw-6 color-F3F3F3 fs-md-18 lh-md-22">
        Choose Plan
      </h4>
      <p class="fs-14 lh-18 fw-4 color-9DA6BF pb-md-4">{{ data.packName }}</p>
    </div>
    <button type="button" class="btn p-0" (click)="close()" aria-label="Close">
      <x-icon iconColor="#FFB800" width="20px" height="20px" aria-hidden="true"></x-icon>
    </button>
  </div>
  <app-loader class="width-max" *ngIf="isLoading"></app-loader>
  <div
    class="flex-row full content-center overflow-hidden overflow-x max-height-md-68-vh overflow-y-md overflow-hidden-md"
    *ngIf="!isLoading">
    <div
      class="flex-row full flex-wrap row-gap-32 column-gap-32 row-gap-md-20 column-md-gap-14 content-between-md flex-wrap-ms"
      *ngIf="subscriptionPlanData.length">
      <ng-container *ngFor="let plan of subscriptionPlanData">
        <div tabindex="0" role="button" aria-label="Select Plan" *ngIf="!plan.isTrial"
          class="flex-row column pay-card flex-md-0 content-between min-height-md-160-px"
          [ngClass]="{ selected: plan?._id === selectedPlan?._id }" (click)="selectedPlan = plan"
          (keydown.enter)="$any($event.currentTarget).click()"
          (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
          <div class="flex-row full column align-start duration row-gap-16 column-md-reverse">
            <div class="height-24-px full">
              <div *ngIf="plan.duration === '3M'" class="flex-row align-center column-gap-4 badge">
                <img src="assets/trading/Sparkle.svg" alt="Popular" class="width-14-px height-14-px">
                <span class=" fs-12 lh-16 fw-5 fs-md-10 lh-md-13">Popular</span>
              </div>
            </div>
            <p class="fs-20 lh-28 fw-4">
              {{ plan.duration | planDuration }} <br />Subscription
            </p>
          </div>

          <div
            class="flex-row pt-md-65 flex-row-md-reverse full column price align-center-md content-end-md column-md-gap-0">
            <div class="flex-row content-between full align-center">
              <p class="fs-20 lh-28 fw-6 color-F3F3F3 mb-12 fs-md-18 lh-md-22 mb-md-0 white-space-wrap">
                <span class="d-none-md">Just</span>
                {{
                (plan.discountedPrice && plan.amount > plan.discountedPrice
                ? plan.discountedPrice
                : plan.amount
                ) | currency : "INR" : "symbol" : "1.0-0"
                }}
              </p>
              <p class="fs-16 lh-28 fw-4 mb-4 mb-md-0 ml-md-5 fs-md-12 lh-md-15 color-9DA6BF"
                style="text-decoration-line: line-through"
                *ngIf="plan.discountedPrice && plan.amount > plan.discountedPrice">{{ plan.amount | currency : "INR" :
                "symbol" : "1.0-0" }}
              </p>
            </div>
            <button type="button" class="btn d-none-md" (click)="goToSubscription(plan)">
              {{ isExpired ? "Renew" : "Subscribe" }}
            </button>
          </div>
        </div>
        <div *ngIf="plan.isTrial && trialEligible" tabindex="0" role="button" aria-label="Select Plan"
          class="flex-row column flex-1 pay-card content-between min-height-md-160-px"
          [ngClass]="{ selected: plan?._id === selectedPlan?._id }" (click)="selectedPlan = plan"
          (keydown.enter)="$any($event.currentTarget).click()"
          (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
          <div class="flex-row full column align-start duration row-gap-16 column-md-reverse">
            <div class="height-24-px full"></div>
            <p class="fs-20 lh-28 fw-4">
              {{ plan.trialDays }} Days <br />
              <span class="d-none-md d-block">Free trial</span>
            </p>
          </div>
          <div class="flex-row full column price align-start-md content-start-md column-md-gap-16">
            <p class="fs-20 lh-28 fw-6 color-F3F3F3 mb-12 fs-md-18 lh-md-22 mb-md-0">
              Free Trial
            </p>
            <button type="button" class="btn d-none-md" (click)="goToSubscription(plan)">
              Subscribe
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="!subscriptionPlanData.length">
      <p class="fs-16 color-F3F3F3">You are currently subscribed to the pack and currently there are no more options</p>
    </div>
  </div>
  <div class="flex-row border-radius-16 p-25 p-md-18 pt-md-22 combo_box mt-30 mb-md-30 full d-none">
    <div class="flex-1 max-width-300-px flex-row column align-start">
      <h4 class="fs-24 fs-md-18 lh-md-24 mb-md-0 lh-32 fw-6 color-EAEAEB mb-3">
        Combo Deal
      </h4>
      <span class="fs-12 fw-3 lh-16 color-FAFAFA d-none d-block-md">Equity + FnO</span>
      <span class="fs-16 lh-28 fw-4 color-F3F3F3 d-none-md">2 month subscription</span>
      <span class="badge fs-14 fs-md-10 fw-4 color-212129 position-relative z-index-999">Popular</span>
      <div class="column flex-row d-none d-block-md mt-md-16">
        <span class="fs-18 fw-7 lh-28 color-F3F3F3 mb-4">{{
          "2000" | currency : "INR" : "symbol" : "1.0-0"
          }}</span>
        <span class="fs-12 fw-4 lh-18 color-9DA6BF ml-md-5">{{
          "2500" | currency : "INR" : "symbol" : "1.0-0"
          }}</span>
      </div>
    </div>
    <div class="flex-1 combo_inner mr-47 d-none-md">
      <ul class="list-style-none pl-25">
        <li class="mb-19">
          <span class="fs-12 fw-3 lh-16 color-FAFAFA">Equity</span>
          <h5 class="fs-16 fw-4 lh-28 color-F3F3F3">Equity demolisher</h5>
        </li>
        <li>
          <span class="fs-12 fw-3 lh-16 color-FAFAFA">FnO</span>
          <h5 class="fs-16 fw-4 lh-28 color-F3F3F3">Pack Name</h5>
        </li>
      </ul>
    </div>
    <div class="flex-1 max-width-300-px">
      <div class="flex-row content-between align-center flex-wrap">
        <span class="fs-16 fw-4 color-F3F3F3 text-right d-none d-block-md">2 month subscription</span>
        <div class="column flex-row d-none-md">
          <span class="fs-16 fw-4 lh-28 color-F3F3F3 mb-4">{{
            "2000" | currency : "INR" : "symbol" : "1.0-0"
            }}</span>
          <span class="fs-20 fw-6 lh-28 color-F3F3F3 mb-8">Just {{ "2500" | currency : "INR" : "symbol" : "1.0-0"
            }}</span>
        </div>
        <div class="column flex-row full-md mt-md-18">
          <span class="fs-16 fw-6 color-01B186 text-right">13% Off</span>
        </div>
      </div>
      <div class="d-none-md">
        <button
          class="pt-12 pb-12 pl-28 pr-28 fs-16 fw-6 lh-18 border-color-FFC727 text-yellow border-radius-10 bg-none cursor-pointer full"
          type="button">
          Subscribe
        </button>
      </div>
    </div>
  </div>
  <!-- <div
      class="flex-row full content-center bottom-info pt-16 pb-14 pl-16 pr-16 pt-md-9 pl-md-10 pr-md-10 pb-md-9 mb-md-60">
      <p class="fs-14 lh-18 fw-4">Subscribe to pickright advisor first to avail ₹100 Off on this advisor</p>
      <img src="assets/trading/right-arrow.svg" class="ml-18" alt="">
  </div> -->
  <div class="flex-row full content-center d-none d-flex-md mt-20">
    <button *ngIf="subscriptionPlanData.length" type="button" [disabled]="!selectedPlan" class="btn btn-yellow full"
      (click)="goToSubscription()">
      Continue
    </button>
  </div>
</div>